import React, { useContext, useState, useEffect, useMemo } from 'react';
import { auth } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";
import { dotoniwoofApi } from '../api/dotoniwooApi';

const AuthContext = React.createContext();

const useAuth = () => {
  return useContext(AuthContext);
};

const AuthProvider = ({ children }) => {
  const [user, changeUser] = useState();
  const [charge, changeCharge] = useState(true);
  const [roleId, setRoleId] = useState(() => {
    const stored = localStorage.getItem('role_id');
    return stored ? parseInt(stored, 10) : null;
  });
  const [idUser, setIdUser] = useState(() => {
    const stored = localStorage.getItem('id_user');
    return stored ? parseInt(stored, 10) : null;
  });
  const [idEmployee, setIdEmployee] = useState(() => {
    const stored = localStorage.getItem('id_employee');
    return stored ? parseInt(stored, 10) : null;
  });
  const [employeeRoleName, setEmployeeRoleName] = useState(() => {
    return localStorage.getItem('employee_role_name') || null;
  });

  // Solo GERENTE_VENTA o ADMINISTRADOR pueden ver todas las citas con sus groomers
  const canSeeAllAppointments = useMemo(() => {
    const role = (employeeRoleName || '').toUpperCase();
    return role === 'GERENTE_VENTA' || role === 'ADMINISTRADOR';
  }, [employeeRoleName]);

  useEffect(() => {
    const cancelSubscription = onAuthStateChanged(auth, async (authUser) => {
      changeUser(authUser);

      if (authUser && authUser.email) {
        const storedRoleId = localStorage.getItem('role_id');
        if (storedRoleId) setRoleId(parseInt(storedRoleId, 10));

        try {
          const { data } = await dotoniwoofApi.get(`user.php/${authUser.email}`);
          // Soporta respuesta data.data (objeto) o data.message (array) según backend
          const userData = data?.data
            ? data.data
            : Array.isArray(data?.message) && data.message.length
              ? data.message[0]
              : null;

          if (userData) {
            const rid = userData.id_role != null ? userData.id_role : storedRoleId;
            if (rid != null) {
              setRoleId(parseInt(rid, 10));
              localStorage.setItem('role_id', rid);
            }
            if (userData.id_user != null) {
              setIdUser(userData.id_user);
              localStorage.setItem('id_user', String(userData.id_user));
            }
            if (userData.id_employee != null) {
              setIdEmployee(userData.id_employee);
              localStorage.setItem('id_employee', String(userData.id_employee));
            }
            if (userData.employee_role_name != null) {
              setEmployeeRoleName(userData.employee_role_name);
              localStorage.setItem('employee_role_name', userData.employee_role_name);
            }
          }
        } catch (error) {
          console.error('Error al obtener usuario:', error);
        }
      } else {
        setRoleId(null);
        setIdUser(null);
        setIdEmployee(null);
        setEmployeeRoleName(null);
        localStorage.removeItem('role_id');
        localStorage.removeItem('id_user');
        localStorage.removeItem('id_employee');
        localStorage.removeItem('employee_role_name');
      }

      changeCharge(false);
    });
    return cancelSubscription;
  }, []);

  const value = useMemo(
    () => ({
      user,
      roleId,
      idUser,
      idEmployee,
      employeeRoleName,
      canSeeAllAppointments
    }),
    [user, roleId, idUser, idEmployee, employeeRoleName, canSeeAllAppointments]
  );

  return (
    <AuthContext.Provider value={value}>
      {!charge && children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext, useAuth };